const translations = {
    chocolateEggsCollected: {
        ar: "بيض الشوكولاتة المجمع",
        da: "ChokoladeÆg indsamlet",
        de: "Schokoladeneier gesammelt",
        en: "Chocolate Eggs Collected",
        es: "Huevos de chocolate obtenidos",
        fi: "Kerätyt suklaamunat",
        fr: "Œufs en chocolat récupérés",
        id: "Telur Cokelat Diambil",
        it: "uova di cioccolato accumulate",
        ja: "集めたチョコレートエッグ",
        ko: "수집한 초콜릿 달걀 수",
        ms: "Telur Coklat Dikumpul",
        nl: "Chocolade-eitjes verzameld",
        pt: "Ovos de chocolate coletados",
        ru: "Собранные шоколадные яйца",
        th: "ไข่ช็อกโกแลตที่ได้เก็บแล้ว",
        tr: "Toplanan Çikolata Yumurta",
        vi: "Số Trứng sô cô la đã thu thập",
        zh: "已收集的巧克力蛋",
        "zh-hans": "已收集的巧克力蛋",
    },
    day: {
        ar: "اليوم",
        da: "Dag",
        de: "Tag",
        en: "Day",
        es: "Día",
        fi: "Päivä",
        fr: "Jour",
        id: "Hari",
        it: "Giorno",
        ja: "日",
        ko: "일",
        ms: "Hari",
        nl: "Dag",
        pt: "Dia",
        ru: "День",
        th: "วัน",
        tr: "Gün",
        vi: "Ngày",
        zh: "活動日",
        "zh-hans": "活动日",
    },
} as const;

type TranslationKey = keyof typeof translations;
type Locale = keyof (typeof translations)[TranslationKey];

export function translate(key: TranslationKey, lang: string): string {
    const entry = translations[key];
    return (entry[lang as Locale] ?? entry.en) as string;
}
